/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import { css } from "styled-components";
import {mediaHelper} from "../../utils/src";
import Colors from 'constants/Colors';

export const Container = styled.div`
  background-color: ${Colors.WHITE};
  margin-bottom: 10px;
  width: 100%;
`;

export const ItemMenu = styled.div`
.icon-arrow-up-primary-color {
  width: 30px;
  height: 10px;
  min-width: 10px;
  transition: transform ease-in-out 200ms;
  
  &:before{
    background-size: 100%;
    width: 80%;
    height: 80%;
    margin: 10%;
  }
  
  &.closed {
    transform: rotate(180deg);
  }
}
`;

export const CardHeader = styled.div`
  display: flex;
  text-transform: uppercase;
  width: 100%;

  >h1{
    font-size: 28px;
    font-weight: 900;
    cursor: pointer;
  }

  > div {
    &.closed {
      transform: rotate(180deg);
    }
  }
  `;
  
export const PopUpMenu = styled.div`
  background-color: #FFFFFF;
  font-size: 12px;
  font-weight: 600;
  height: auto;
  width: auto;
  padding: 15px;
  margin-left: 25px;
  margin-top: 15px;
  z-index: 5;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
  border-radius: 16px;
  box-shadow: 1px 2px 14px -10px black;
  opacity: 0;
  >div{
    cursor: pointer;
    margin-top: 5px;
  }

  &.fadeInLeft {
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
    -webkit-animation-duration: 0.4s;
    animation-duration: 0.4s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    }
    @-webkit-keyframes fadeInLeft {
    0% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
    }
    100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
    }
    }
    @keyframes fadeInLeft {
    0% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
    }
    100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
    }
    }

    &.fadeOutLeft {
      -webkit-animation-name: fadeOutLeft;
      animation-name: fadeOutLeft;
      -webkit-animation-duration: 0.4s;
      animation-duration: 0.4s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
      }
      @-webkit-keyframes fadeOutLeft {
      0% {
      opacity: 1;
      }
      100% {
      opacity: 0;
      -webkit-transform: translate3d(-100%, 0, 0);
      transform: translate3d(-100%, 0, 0);
      }
      }
      @keyframes fadeOutLeft {
      0% {
      opacity: 1;
      }
      100% {
      opacity: 0;
      -webkit-transform: translate3d(-100%, 0, 0);
      transform: translate3d(-100%, 0, 0);
      display: none;
      }
      }
`;